import { gql, useQuery } from '@apollo/client';
import {
  TRANSLATED_STRING_FIELDS,
  translateBackend,
} from '@assets/i18n/config';
import { useParams } from 'react-router-dom';

export const FETCH_ORGANIZATION_NAME = gql`
  query fetchOrgName($id: String!) {
    fetchOrganization(organizationId: $id) {
      organization { translatedName { ${TRANSLATED_STRING_FIELDS} } }
    }
  }
`;

export const OrgDetailsBreadcrumb = () => {
  const { id } = useParams();
  const { data } = useQuery(FETCH_ORGANIZATION_NAME, { variables: { id } });

  return data
    ? translateBackend(data.fetchOrganization.organization.translatedName)
    : id;
};
